import React  from 'react';
import PropTypes from 'prop-types';
import './ReplaySection.scss';

const ReplaySection = (props) => {
    return (
        <div className="replay-section">
            <button href="#" onClick={props.handleClick} className="replay-section__link no-btn-styles">REPLAY SECTION</button>
        </div>
        
    )
}

ReplaySection.propTypes = {
    handleClick: PropTypes.func.isRequired
}

export default ReplaySection
